<template>
    <div
        :class="{
            loans: true,
            'padded-page': true,
            rejected: reviewData?.has_been_rejected_on_all_loans,
            none: hasTakenALoan,
        }"
        ref="screenWrapper"
    >
        <p v-if="reviewData?.has_been_rejected_on_all_loans" class="mb-4 font-satoshi_m">
            Rejections sting, we know 💔. <br /><br />
            Let’s rebuild your credit strength together, and in the meantime, explore our savings and investment options to stay on top of your
            finances.
        </p>
        <p v-else-if="hasTakenALoan" class="mb-4 font-satoshi_m">
            You’ve never applied for a loan on Sycamore 😔. <br /><br />
            Feeling a little strapped for cash? <br /><br />
            Our business and salary loans are tailored to meet your needs.
        </p>
        <template v-else>
            <div class="mb-5">
                <p>Sycamore disbursed</p>
                <div
                    :class="{
                        grid: true,
                        'grid-cols-2': reviewData?.total_uk_loans_collected > 0,
                        'gap-4': true,
                        'my-4': true,
                    }"
                >
                    <div
                        v-if="reviewData?.total_loans_collected > 0"
                        class="bg-yInRev-orange text-white font-satoshi_b px-4 py-3 rounded-xl text-2xl"
                    >
                        {{ $format.renderCurrency(reviewData?.total_loans_collected, "compact", "NGN") }}
                    </div>
                    <div
                        v-if="reviewData?.total_uk_loans_collected > 0"
                        class="bg-yInRev-orange text-white font-satoshi_b px-4 py-3 rounded-xl text-2xl"
                    >
                        {{ $format.renderCurrency(reviewData?.total_uk_loans_collected, "compact", "GBP") }}
                    </div>
                </div>
                <p>to you in loans in 2025.</p>
            </div>
            <div>
                <p>You paid back</p>
                <div
                    :class="{
                        grid: true,
                        'grid-cols-2': reviewData?.total_uk_loans_repaid > 0,
                        'gap-4': true,
                        'my-4': true,
                    }"
                >
                    <div v-if="reviewData?.total_loans_repaid > 0" class="bg-yInRev-orange text-white font-satoshi_b px-4 py-3 rounded-xl text-2xl">
                        <CountUpNumber :endVal="reviewData?.total_loans_repaid ?? 0" currency="₦" />
                    </div>
                    <div
                        v-if="reviewData?.total_uk_loans_repaid > 0"
                        class="bg-yInRev-orange text-white font-satoshi_b px-4 py-3 rounded-xl text-2xl"
                    >
                        <CountUpNumber :endVal="reviewData?.total_uk_loans_repaid ?? 0" currency="₦" />
                    </div>
                </div>
                <p>in loans.</p>
            </div>
        </template>
    </div>
</template>

<script>
import CountUpNumber from "./CountUp.vue";

export default {
    components: {
        CountUpNumber,
    },

    props: {
        reviewData: Object,
    },

    computed: {
        hasTakenALoan() {
            return this.reviewData?.total_loans_collected + this.reviewData?.total_uk_loans_collected <= 0;
        },
    },

    mounted() {
        const screenWrapper = this.$refs.screenWrapper;
        const hammer = new Hammer(screenWrapper);

        hammer.on("tap", () => {
            if (this.currentScreen === 0) return;
            this.$emit("goForward");
        });
    },
};
</script>

<style scoped>
.loans {
    color: white;
    min-height: 100vh;

    background-color: #ff6b33;
    background-image: url("../../assets/images/year-in-review/loans.svg");
    background-size: 80% auto;
    background-repeat: no-repeat;
    background-position: bottom right;
}

.loans.rejected {
    background-image: url("../../assets/images/year-in-review/loans-rejected.svg");
}

.loans.none {
    background-image: url("../../assets/images/year-in-review/loans-none.svg");
}

@media (max-height: 750px) {
    .loans {
        background-size: 60% auto;
    }
}
</style>
